'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _reportMap = require('./reportMap.component');

var _reportMap2 = _interopRequireDefault(_reportMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reportMapModule = _angular2.default.module('reportMap', [_angularUiRouter2.default])

// .config(($stateProvider) => {
//   "ngInject";
//   $stateProvider
//   .state('reportMap', {
//     url: '/reportMap',
//     component: 'reportMap'
//   });
// })

.component('reportMap', _reportMap2.default).name;

exports.default = reportMapModule;


// WEBPACK FOOTER //
// ./client/app/common/reportMap/reportMap.js